import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n  <section class=\"wrapper-toggle-product-overview-home-loans "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"scope") : stack1), depth0))
    + " squeezebox-wrapper\" data-accordion-type=\"accordion\" data-route=\"mortgage\">\r\n    <div class=\"row\">\r\n      <div class=\"small-12 column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":59,"column":17}}})) != null ? stack1 : "")
    + "\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <section class=\"squeezebox-wrapper\" id=\"toggleProductsAccordion\" data-accordion-type=\"accordion\" data-one-at-a-time=\"false\">\r\n            <div class=\"squeezebox-panels\" data-one-at-a-time=\"true\">\r\n              <div class=\"squeezebox-panel\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Panel\">\r\n                <a href=\"javascript:void(0)\" class=\"panel-header spa-oline transparent\"\r\n                  data-panel=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Panel\"\r\n                  aria-label=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headerText") || (depth0 != null ? lookupProperty(depth0,"headerText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headerText","hash":{},"data":data,"loc":{"start":{"line":12,"column":30},"end":{"line":12,"column":46}}}) : helper))) != null ? stack1 : "")
    + "\"\r\n                  id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Accordion\" role=\"button\">\r\n                  <span class=\"spa-squeezebox-arrow spa-icon\"></span>\r\n                  <h4 class=\"spa-squeezebox-heading toggle-product-header-home-loans\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headerText") || (depth0 != null ? lookupProperty(depth0,"headerText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headerText","hash":{},"data":data,"loc":{"start":{"line":15,"column":86},"end":{"line":15,"column":102}}}) : helper))) != null ? stack1 : "")
    + "</h4>\r\n                  <span class=\"ada-hidden\"></span>\r\n                </a>\r\n                <div class=\"panel-content transparent\" aria-labelledby=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"accordion") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "Accordion\">\r\n                  <div class=\"content\">\r\n                    <div class=\"row\">\r\n                      <div class=\"column medium-6 small-12 toggle-product-left-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"left") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":24},"end":{"line":35,"column":33}}})) != null ? stack1 : "")
    + "                      </div>\r\n                      <div class=\"column medium-6 small-12 toggle-product-right-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"right") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":24},"end":{"line":51,"column":33}}})) != null ? stack1 : "")
    + "                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </section>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <div class=\"column medium-12 toggle-product-content-home-loans\">\r\n                            <p class=\"toggle-product-content-header-home-loans\"><strong>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headerText") || (depth0 != null ? lookupProperty(depth0,"headerText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headerText","hash":{},"data":data,"loc":{"start":{"line":24,"column":88},"end":{"line":24,"column":106}}}) : helper))) != null ? stack1 : "")
    + "</strong></p>\r\n                            <ul class=\"toggle-product-list-home-loans\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":30},"end":{"line":30,"column":39}}})) != null ? stack1 : "")
    + "                            </ul>\r\n                            <p class=\"toggle-product-learn-more-link "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"reset-margin-class") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":69},"end":{"line":33,"column":72}}})) != null ? stack1 : "")
    + "\"> "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + " </p>\r\n                          </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                <li class=\"toggle-product-list-item-home-loans\">\r\n                                  <p class=\"toggle-product-text-home-loans\">"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n                                </li>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    return " reset-margin ";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n  <section class=\"wrapper-toggle-product-home-loans "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"scope") : stack1), depth0))
    + "\" data-route=\"mortgage\">\r\n\r\n    <section class=\"row\">\r\n      <div class=\"column small-12\">\r\n        <h3 class=\"toggle-product-header-home-loans\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"headerText") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n      </div>\r\n    </section>\r\n\r\n    <section class=\"row\">\r\n      <div class=\"row\">\r\n        <div class=\"column medium-6 small-12\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"left") : stack1),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":78,"column":10},"end":{"line":91,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n\r\n        <div class=\"column medium-6 small-12\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"right") : stack1),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":95,"column":10},"end":{"line":108,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n      </div>\r\n    </section>\r\n\r\n  </section>\r\n\r\n";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"column medium-12 toggle-product-content-home-loans\">\r\n              <h4 class=\"toggle-product-content-header-home-loans\">\r\n                <strong>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"headerLink") : depth0), depth0)) != null ? stack1 : "")
    + "</strong></h4>\r\n              <ul class=\"toggle-product-list-home-loans\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"each","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":83,"column":16},"end":{"line":88,"column":25}}})) != null ? stack1 : "")
    + "              </ul>\r\n            </div>\r\n";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li class=\"toggle-product-list-item-home-loans\">\r\n                    <p class=\"toggle-product-text-home-loans "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"reset-margin-class") : depths[1]),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":85,"column":61},"end":{"line":86,"column":67}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n                  </li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"isProduct") : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":115,"column":11}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/toggle-products-module",
  "version": "3.0.1",
  "id": "toggleProductsModule",
  "containerID": "homeLoansToggleProductsModule",
  "moduleName": "home-loans-toggle-products-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "toggleProductsModule",
  "data": {
    "init": "toggleProductsModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/**
 * @export
 * @class toggleProductsModule
 * @extends {Module}
 */
class toggleProductsModule extends Module {
  /**
  * Creates an instance of toggleProductsModule.
  * @param {Object} options Module Options
  * @param {Object} context Module context
  * @memberof toggleProductsModule
  */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    this.$target = $('#toggleProductsModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
  * @memberof toggleProductsModule module member
  * @Returns {void}
  */
  init() {
    spartaSqueezeboxUtility.init();
  }
}
registerModuleClass({
  moduleClass: toggleProductsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { toggleProductsModule as default, moduleConfig };
